import { Dvr, HealthAndSafety, Monitor, School, SupportAgent, WarningAmber } from '@mui/icons-material';
import iconSchool from 'assets/images/icons/icons8-escola-64.png';
import { lazy } from 'react';
import { Permissions } from 'services/enums';
import { isDevelopmentAccountLicense } from '../routeUtils';
import { DEFAULT_ROUTE, IRouteProps } from '../types';

const CustomerMonitoringPage = lazy(() => import('pages/CustomerMonitoringPage'));
const DeviceMonitoringScreen = lazy(() => import('pages/DeviceMonitoringScreen'));
const MonitoringPage = lazy(() => import('pages/MonitoringPage'));
const MonitoringSchoolPerimeterPages = lazy(() => import('pages/MonitoringSchoolPerimeterPages'));
const OccurrencePage = lazy(() => import('pages/OccurrencePage'));
const SchoolMonitoringPage = lazy(() => import('pages/SchoolMonitoringPage'));
const ServerHealthPage = lazy(() => import('pages/ServerHealthPage'));

const serverHealthRoute: IRouteProps = {
	type: 'collapse',
	name: 'Saúde dos Servidores',
	key: 'server-health',
	icon: <HealthAndSafety />,
	route: `${DEFAULT_ROUTE}/server-health`,
	permissionId: [Permissions.ALL],
	component: <ServerHealthPage />,
	protected: true,
};

export const monitoringRoutes: IRouteProps[] = [
	...(isDevelopmentAccountLicense() ? [serverHealthRoute] : []),
	{
		type: 'collapse',
		name: 'routersNames.monitoring',
		key: 'monit',
		icon: <Monitor />,
		permissionId: [Permissions.EVENTS],
		protected: true,
		collapse: [
			{
				type: 'collapse',
				name: 'routersNames.geral',
				key: 'monitoring',
				icon: <Dvr />,
				route: `${DEFAULT_ROUTE}/monitoring`,
				permissionId: [Permissions.EVENTS],
				component: <MonitoringPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'routersNames.porter',
				key: 'opendoor',
				icon: <Dvr />,
				route: `${DEFAULT_ROUTE}/deviceOpenDoor`,
				permissionId: [Permissions.EVENTS],
				component: <DeviceMonitoringScreen />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'routersNames.schoolMonitoring',
				key: 'school-Monitoring',
				icon: <School />,
				route: `${DEFAULT_ROUTE}/schoolMonitoring`,
				permissionId: [Permissions.SCHOOL_MONITORING_EVENT],
				component: <SchoolMonitoringPage />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'routersNames.perimeterSchool',
				key: 'schoolMonitoring',
				icon: <img src={iconSchool} width={'20px'}></img>,
				route: `${DEFAULT_ROUTE}/MonitoringSchoolPerimeter`,
				permissionId: [Permissions.STUDENT, Permissions.RESPONSIBLE],
				component: <MonitoringSchoolPerimeterPages />,
				protected: true,
			},
			{
				type: 'collapse',
				name: 'routersNames.customerMonitoring',
				key: 'customers',
				icon: <SupportAgent />,
				route: `${DEFAULT_ROUTE}/customers`,
				permissionId: [Permissions.CUSTOMER_RECOGNITION_EVENT],
				component: <CustomerMonitoringPage />,
				protected: true,
			},
		],
	},
	{
		type: 'collapse',
		name: 'Alertas e Ocorrências',
		key: 'occurrences',
		icon: <WarningAmber />,
		route: `${DEFAULT_ROUTE}/occurrences`,
		permissionId: [Permissions.EVENTS],
		component: <OccurrencePage />,
		protected: true,
	},
];
